import * as React from 'react';
import EditorTextDisplay from 'components/EditorTextDisplay';

import { Omit } from 'types';
import { block } from '../utils';
import TrackAsset, { TrackAssetProps } from './TrackAsset';

type InheritedProps = Omit<
  TrackAssetProps,
  'position' | 'sizeBounds' | 'itemClassName'
>;

export interface TextAssetProps extends InheritedProps {
  minWidth?: number;
  position: TrackAssetProps['position']['x'];
  text?: string;
}

const TextAsset: React.SFC<TextAssetProps> = ({
  minWidth,
  position,
  text,
  ...props
}) => (
  <TrackAsset
    {...props}
    itemClassName={block('text-asset')}
    position={{ x: position, y: 0 }}
    sizeBounds={{ minWidth, maxWidth: Infinity }}
  >
    <div className={block('text-asset-inner')}>
      <EditorTextDisplay
        className={block('text')}
        formatTextOptions={{ addDynamicTextPlaceholders: true }}
      >
        {text}
      </EditorTextDisplay>
    </div>
  </TrackAsset>
);

export default TextAsset;
